export default __webpack_public_path__ + "static/media/ComputerSystemsImg.820a154a.jpg";